import { inject, injectable } from '@wix/typesafe-inversify';
import type { IPromiseVoider } from './IPromiseVoider';
import { Services } from '../../ioc/services';
import type { IConsoleLogger } from '../ConsoleLogger/IConsoleLogger';

@injectable()
export class PromiseVoider implements IPromiseVoider {
  constructor(
    @inject(Services.ConsoleLogger)
    private readonly consoleLogger: IConsoleLogger,
  ) {}

  public async executeAndVoid(action: () => Promise<void>) {
    void action().catch((error) => {
      this.consoleLogger.error(error);
    });
  }
}
